import { useMutation } from "@tanstack/react-query";
import { apiV1Endpoint } from "../../../../../api/v1";
import { ApiResponse } from "../../../../../types/api-response";
import axios from "../../../../../utils/axiosInceptor";

type BulkGenerateInvoiceRequestPayload = {
  pdcIds: string[];
  dueDate?: string;
};

const bulkGenerateInvoiceRequest = async (request: BulkGenerateInvoiceRequestPayload) => {
  const { pdcIds, dueDate } = request;

  const url = `${apiV1Endpoint}/booking/bulkGenerateInvoice`;
  const payload = {
    pdcIds,
    ...(dueDate ? { dueDate } : {}),
  };

  const response = await axios.post<ApiResponse>(url, payload);
  return response.data;
};

type UseBulkGenerateInvoiceRequestOptions = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

export const useBulkGenerateInvoiceRequest = (options: UseBulkGenerateInvoiceRequestOptions = {}) => {
  const { onSuccess, onError } = options;

  const { mutateAsync, isPending } = useMutation({
    mutationFn: bulkGenerateInvoiceRequest,
    onSuccess,
    onError,
  });

  return {
    bulkGenerateInvoiceRequest: mutateAsync,
    isPendingBulkGenerateInvoiceRequest: isPending,
  };
};
